var _defs, _g, _g2, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuobi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3e8445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_3-2",
    "data-name": "Layer 3",
    className: "cls-1",
    d: "M0,.2H150v150H0Z",
    transform: "translate(0 -0.2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-2",
    d: "M47.54,39.43a1.15,1.15,0,0,1,.25-.12c.92-.42,1.85-.83,2.77-1.19V19.88a6,6,0,0,0-6-6H19.69V66.22A60,60,0,0,1,47.54,39.43Z",
    transform: "translate(0 -0.2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-2",
    d: "M72.87,71.32h5.54A14.57,14.57,0,0,0,93,56.76V41.15c-3-.52-16.71-.81-19.89-.81C42.34,40.07,17.3,67,19.67,97.62h0V130.9a6,6,0,0,0,6,6H50.54V93.57A22.31,22.31,0,0,1,72.87,71.32Z",
    transform: "translate(0 -0.2)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-2",
    d: "M104.32,111.32a1,1,0,0,1-.24.11c-.92.43-1.85.84-2.78,1.2v18.24a6,6,0,0,0,6,6h24.85V84.53A60,60,0,0,1,104.32,111.32Z",
    transform: "translate(0 -0.2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-2",
    d: "M132.15,53.14h0V19.85a6,6,0,0,0-6-6H101.28V57.17A22.31,22.31,0,0,1,79,79.43H73.41A14.55,14.55,0,0,0,58.84,94v15.61c3.68.55,17.15.86,21,.79a53.07,53.07,0,0,0,21.56-5l.14-.07A53.48,53.48,0,0,0,132.15,53.14Z",
    transform: "translate(0 -0.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/huobi.6b66060b2b7ff7d5128dd98663db7068.svg";
export { ForwardRef as ReactComponent };